import { parseJSON, handleNetworkError, getCookie } from '../../utils'
const kennitala = require('kennitala');


const ALLIANZ_ID='941';


async function _lookupCustomer(kennitala,contractType = null) {
    const apiUrl = contractType ? `/api/v1/customers/${kennitala}/?contractType=VID` : `/api/v1/customers/${kennitala}/`;
    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }
    try {
        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        }).
        then(parseJSON).
        then((response) => {
            return response
        });
    } catch (err) {
        if (typeof handleNetworkError === 'function') handleNetworkError(err);
        throw err;
    }
}

async function lookupKennitala(kTala,filterByContract) {
    if (kennitala.isValid(kTala)) {
        try {
            const a = filterByContract ? await _lookupCustomer(kTala,'VID') : _lookupCustomer(kTala);
            if (a.constructor === Object)
                return a.Customer;
            else
                return a;
        } catch (err) {
            console.log(err);
            return null;
        }
    } else {
        return "Ógild kennitala";
    }
}


function convertPeriodDataToFile(employer,period,periodRows,fileName = null) {
    let lines = [];
    const paymentDay = (new Date()).toISOString().slice(0,10).replace(/-/g,"");
    const paymentPeriod = period.first.toISOString().slice(0,8).replace(/-/g,"");
    const periodStart = period.first.toISOString().slice(0,10).replace(/-/g,"");
    const periodEnd = period.last.toISOString().slice(0,10).replace(/-/g,"");
    // let premiumSum = 0;
    // let counterPremiumSum = 0;
    for (const row of periodRows || []) {
        let premium = row.premium;
        let counterPremium = row.counterPremium;
        if (typeof premium === 'string') {
            premium = Number(premium.replace(/[,.]/g, ''));
        }
        if (typeof counterPremium === 'string') {
            counterPremium = Number(counterPremium.replace(/[,.]/g, ''));
        }
        lines.push(
            [
                employer.EmployerId,
                paymentDay,
                'X',
                ALLIANZ_ID,
                row.kennitala.replace('-',''),
                "      ",
                (Number.isFinite(premium) ? String(Math.round(premium * 100)).padStart(12, '0') : '000000000000'),
                (Number.isFinite(counterPremium) ? String(Math.round(counterPremium * 100)).padStart(12, '0') : '000000000000'),
                "    ",
                periodStart,
                periodEnd,
                '00000'
            ].join('')
        );
        // premiumSum += parseInt(row.premium);
        // counterPremiumSum += parseInt(row.counterPremium);
    }
    // seems we don't need these checksums, after all
    // lines.push(
    //     [
    //         employer.AccountNum,
    //         paymentDay,
    //         'X',
    //         ALLIANZ_ID,
    //         " ".repeat(10),
    //         " ".repeat(6),
    //         (Number.isFinite(premiumSum) ? String(Math.round(premiumSum * 100)).padStart(12, '0') : '000000000000'),
    //         (Number.isFinite(counterPremiumSum) ? String(Math.round(counterPremiumSum * 100)).padStart(12, '0') : '000000000000'),
    //         "   S",
    //         " ".repeat(21)
    //     ].join('')
    // );
    if (!fileName) {
        fileName = employer.EmployerId + "-" + 'skilagrein.txt';
    }
    const text = lines.join('\r\n');
    const blob = new Blob([text], { type: 'text/plain;charset=utf-8' });

    // Try to return a File (supported in modern browsers); if not available return the Blob.
    let file = null;
    try {
        file = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });
    } catch (e) {
        file = null;
    }

    return { text, blob, file };
}

function parseDate(dateString) {
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6) - 1;
    const day = dateString.substring(6, 8);
    return  new Date(year, month, day);
}

function parseAmount(amountStr) {
    const s = (amountStr || '').replace(/^0+/, '') || '0';
    const n = parseInt(s, 10);
    return Number.isFinite(n) ? n / 100 : 0;

}


async function convertFileToPeriodData(input) {
    const readText = (src) => {
        if (typeof src === 'string') return Promise.resolve(src);
        if (src && typeof src.text === 'function') return src.text();
        // fallback FileReader
        return new Promise((resolve, reject) => {
            try {
                const fr = new FileReader();
                fr.onload = () => resolve(fr.result);
                fr.onerror = reject;
                fr.readAsText(src);
            } catch (err) {
                reject(err);
            }
        });
    };

    const text = await readText(input);

    const lines = (text || '').split(/\r?\n/).filter(Boolean);
    if (!lines.length) {
        return { employer: {}, period: { first: null, last: null }, periodRows: [] };
    }

    const periodRows = [];
    const firstLine = lines[0];
    
    const fundId = firstLine.match(/^.{19}(\d{3})/);
    if (!firstLine[18] !== 'X' && fundId[1] !== ALLIANZ_ID) {
        throw new Error("Rangt auðkenni sjóðs. Við styðjum aðeins Allianz (941). (lína 1)");
    }

    let lineIdx = 1;
    try {        
        const periodEndStr = firstLine.slice(66,66+8);
        const periodStartStr = firstLine.slice(74,74+8);

        const periodFirst = parseDate(periodStartStr);
        const periodLast = parseDate(periodEndStr);


        const employerKennitala = firstLine.match(/\d{10}/)[0];
        let employerInfo = await lookupKennitala(employerKennitala, false);
        let employer = { 
            EmployerId: employerKennitala,
            Name: employerInfo.Name
        };

        let paymentDay = parseDate(firstLine.match(/^.{10}(\d{8})/)[1]);
        // let premiumSum = 0;
        // let counterPremiumSum = 0;
        lineIdx = 2;
        for (const line of lines) {
            if (!line) {
                continue;
            }
            const premiumStr = line.slice(38,38 + 12) || '';
            const counterPremiumStr = line.slice(50,50 + 12) || '';

            let kennitala = line.match(/^.{22}(\d{10})/)[1];

            const fundId = line.match(/^.{19}(\d{3})/);

            if (!line[18] !== 'X' && fundId[1] !== ALLIANZ_ID) {
                throw new Error("Rangt auðkenni sjóðs. Við styðjum aðeins Allianz (941)");
            }

            const premium = parseAmount(premiumStr);
            const counterPremium = parseAmount(counterPremiumStr);

            let kennitalaInfo = await lookupKennitala(kennitala, true);
            periodRows.push({
                kennitala: kennitala || '',
                name: kennitalaInfo && kennitalaInfo.constructor === Object ? kennitalaInfo.Name : kennitalaInfo,
                error: kennitalaInfo && kennitalaInfo.constructor !== Object ? kennitalaInfo : '',
                premium: premium,
                counterPremium: counterPremium,
                periodStart: periodFirst,
                periodEnd: periodLast,
            });
            lineIdx++;
            // premiumSum += premium;
            // counterPremiumSum += counterPremium;
        }

        // const premiumSumInFile = parseAmount(lastLine.slice(38,38 + 12) || '');
        // const counterPremiumSumInFile = parseAmount(lastLine.slice(50,50 + 12) || '');
        // if ((premiumSum !== premiumSumInFile) || (counterPremiumSum !== counterPremiumSumInFile)) {
        //     throw new Error("Samtölur iðgjalda í skrá standast ekki prófun. Vinsamlegast lagið skrána og reynið aftur");
        // }    
        return {
            employer,
            period: { first: periodFirst, last: periodLast, paymentDay },
            periodRows
        };

    } catch (err) {
        const msg = `Ekki tókst að lesa skrá með skilagrein. Villa í línu ${lineIdx}: ${err && err.message ? err.message : String(err)}`;
        const enhanced = new Error(msg);
        // preserve original for debugging
        enhanced.originalError = err;
        if (err && err.stack) enhanced.stack = err.stack;
        throw enhanced;        
    }
}


async function uploadFiles(files, kennitala) {
    const data = files.map((file) => {
        return {
            data: file.text,
            title: file.file.name,
        }
    });
    const apiUrl = "/api/v1/skilagrein/upload/"+kennitala+"/";

    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCookie("csrftoken"),
    }
    return await fetch(apiUrl, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'include',
    });
}

async function requestNewRLKey(kennitala) {
    const apiUrl = "/api/v1/skilagrein/RLwebkey/"+kennitala+"/";

    let headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': getCookie("csrftoken"),
    }
    return await fetch(apiUrl, {
        headers: headers,
        method: 'POST',
        credentials: 'include',
    });

}

export {
    convertPeriodDataToFile,
    convertFileToPeriodData,
    uploadFiles,
    requestNewRLKey
}
